// @flow

export function insertStyle (style: string) {
  const styleElement = document.createElement('style')
  styleElement.innerHTML = style
  window.document.body.insertAdjacentElement('beforeend', styleElement)
}

export function cssWrapper (wrapper: string, css: string): string {
  return css.replace(/(\.[^{]+{)/g, (match: string, group1: string) => {
    if (group1.includes(wrapper)) return group1
    return `${wrapper} ${group1}`
  })
}

export function getParents (wrapper: Node): Array<Node> {
  const parents: Array<Node> = []
  for (let parent = wrapper; parent && parent !== document; parent = parent.parentNode) {
    parents.push(parent)
  }
  return parents
}
